import React from 'react';
import { authRoles } from 'app/auth';

// TODO Update path to use ID not name
export const TrainingsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.instructor, //['admin', 'staff', 'user']
	routes: [
		{
			path: '/trainings',
			component: React.lazy(() => import('./Trainings'))
		}
	]
};
